import React from "react";
import imageUrl from "utils/imageUrl";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import AllCollectionCard from "./AllCollectionCard";
import CollectionDetails from "./CollectionDetails";
import { useState } from "react";
function AllCollectionlayout({ data }) {
  const [visible, setVisible] = useState(9);
  const showMoreItems = () => {
    setVisible((prevValue) => prevValue + 3);
  };
  return (
    <>
      <section
        class="banner__alt bg__img"
        data-background="assets/images/banner/banner-two-bg.png"
        style={{
          backgroundImage: `url(${imageUrl("banner/banner-two-bg.png")})`,
        }}
      >
        <div class="container">
          <div class="banner__alt__area">
            <h1 class="neutral-top neutral-bottom">All Properties</h1>
          </div>
        </div>
      </section>
      <section className="p__details faq ">
        <div className="container">
          <div className="p__details__area">
            <div className="row">
              <div className="col-lg-8">
                <div className="p__details__content pt-5 title__margin">
                  <div className="intro">
                    <h3>Meezo</h3>
                    <p>
                      <i className="fa-solid fa-location-dot"></i> Gegular ,
                      Penang
                    </p>
                  </div>
                  <CollectionDetails />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="p__details__sidebar">
                  <div className="group birinit">
                    <h6>Social Sites </h6>
                    <div className="social text-start">
                      <a href="javascript:void(0)">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                      <a href="javascript:void(0)">
                        <i className="fab fa-twitter"></i>
                      </a>
                      <a href="javascript:void(0)">
                        <i className="fab fa-instagram"></i>
                      </a>
                      <a href="javascript:void(0)">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="properties__filter section__space__bottom">
        <div class="container wow fadeInUp">
          <div class="properties__filter__wrapper">
            <h6>
              Showing <span>16</span> properties
            </h6>

            <div class="grid__wrapper">
              {/* <Select
                closeMenuOnSelect={false}
                components={animatedComponents}
                defaultValue={[collectionOptions[0]]}
                isMulti
                options={collectionOptions}
                className="basic-multi-select"
                classNamePrefix="select"
              /> */}
              <select class="grid__select">
                <option data-display="Sort By">Sort By</option>
                <option value="grid">Sub Sales</option>
                <option value="list">New Launch</option>
              </select>

              {/* <a
                href="javascript:void(0)"
                class="grid__btn grid__view grid__btn__active"
              >
                <i class="fa-solid fa-grip"></i>
              </a>
              <a href="javascript:void(0)" class="grid__btn grid__list">
                <i class="fa-solid fa-bars"></i>
              </a> */}
            </div>
          </div>
          <div className="row">
            {data.slice(0, visible).map((item, index) => (
              <AllCollectionCard key={index} data={item} />
            ))}
          </div>
          <div class="cta__btn">
            <a
              href="javascript:void(0)"
              class="button button--effect"
              onClick={showMoreItems}
            >
              Load More
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default AllCollectionlayout;
